/**
 * Shared design tokens for the BetBond consumer web app.
 * Mirrors BetBond/src/screens/DashboardScreen/DashboardScreenStyles.js (THEME)
 * so web and mobile read as one product.
 */
export const THEME = {
  background:  "#0A0F18",
  surface:     "#111927",
  surfaceLite: "#1A2332",
  primary:     "#1E88E5",
  primarySoft: "#64B5F6",
  secondary:   "#1565C0",
  success:     "#2ECC71",
  warning:     "#FFA726",
  error:       "#EF5350",
  text: {
    primary:   "#FFFFFF",
    secondary: "rgba(255,255,255,0.65)",
    tertiary:  "rgba(255,255,255,0.45)",
    muted:     "rgba(255,255,255,0.38)",
  },
  hairline:    "rgba(30,136,229,0.20)",
};

export const PRIMARY_RGBA = "30,136,229";
